// extracted by mini-css-extract-plugin
export default {"footerContainer":"DeleteConversation__footerContainer___frubI","skeleton-loading":"DeleteConversation__skeleton-loading___JuwN_"};